// @ts-nocheck
import * as React from "react";

const ArrowiOSUpward: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M18 15a1 1 0 01-.64-.23L12 10.29l-5.37 4.32a1 1 0 01-1.41-.15 1 1 0 01.15-1.41l6-4.83a1 1 0 011.27 0l6 5a1 1 0 01.13 1.41A1 1 0 0118 15z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(ArrowiOSUpward);
